import router from '@/router/router'
import store from '@/store/store'

// copied from vue-matomo
function buildBaseUrl(router) {
  const loc = window.location
  let routerBase = '/'
  if (router.options.base) {
    // Trim '/' at start and end, replace with single '/' at start and end
    routerBase = router.options.base.replace(/^\//, '').replace(/\/+$/, '')
    routerBase = `/${routerBase}`
  }
  // Protocol may or may not contain a colon
  let protocol = loc.protocol
  if (protocol.slice(-1) !== ':') {
    protocol += ':'
  }
  const maybeHash = router.mode === 'hash' ? '/#' : ''
  return protocol + '//' + loc.host + routerBase + maybeHash
}

export function subscribeToRouter(callback) {
  const baseUrl = buildBaseUrl(router)
  const baseUrlHasSlash = baseUrl.slice(-1) === '/'

  // eslint-disable-next-line no-unused-vars
  router.afterEach((to, from) => {
    // Unfortunately the window location is not yet updated here
    // We need to make our own url using the data provided by the router
    const url = baseUrl + (baseUrlHasSlash ? to.fullPath.replace(/^\//, '') : to.fullPath)

    if (to.meta.analyticsIgnore) {
      return
    }

    callback(url)
  })
}

export function currentUser() {
  return store.getters.user
}

export function onUserChange(callback) {
  store.subscribe(mutation => {
    if (mutation.type === 'SET_CURRENT_USER') {
      callback(mutation.payload)
    }
  })
}
